import React from 'react';

// The Context 
const RideUnitContext = React.createContext({});

// RideUnitCtx Provider
const RideUnitCtxProvider = ({children}) => {

    const [currentIdx, setCurrentIdx] = React.useState(0);
    const [currentLocation, setCurrentLocation] = React.useState("us");
    const [ride] = React.useState(false)

    // Context values passed to consumer
    const value = {
        currentIdx,   
        setCurrentIdx,
        currentLocation,
        setCurrentLocation,
        ride
    };

    return (
        <RideUnitContext.Provider value={value}>
            {children}
        </RideUnitContext.Provider>
    )
}

const useRideUnitContext = () => React.useContext(RideUnitContext);

export { RideUnitCtxProvider, useRideUnitContext }

